interface ConfirmDialogProps {
  open: boolean;
  title: string;
  message: string;
  confirmLabel?: string;
  danger?: boolean;
  busy?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}
export default function ConfirmDialog({
  open,
  title,
  message,
  confirmLabel = "Confirm",
  danger = true,
  busy = false,
  onConfirm,
  onCancel,
}: ConfirmDialogProps) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4" onClick={onCancel}>
      <div
        className="w-full max-w-sm rounded-xl border border-line bg-panel p-5 shadow-panel"
        onClick={(event) => event.stopPropagation()}
      >
        <h3 className="font-mono text-sm font-semibold text-ink">{title}</h3>
        <p className="mt-2 font-mono text-xs leading-relaxed text-ink-dim">{message}</p>
        <div className="mt-5 flex justify-end gap-2">
          <button
            onClick={onCancel}
            disabled={busy}
            className="rounded-md border border-line px-3 py-1.5 font-mono text-xs text-ink-dim transition hover:border-line disabled:opacity-50"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            disabled={busy}
            className={`rounded-md px-3 py-1.5 font-mono text-xs font-semibold transition disabled:opacity-50 ${
              danger ? "bg-sell text-void hover:bg-sell/90" : "bg-turquoise text-void hover:bg-turquoise/90"
            }`}
          >
            {busy ? "Working…" : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
